














import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class LoadMore extends Vue {
  @Prop({ default: "sync-alt" })
  public icon!: string;
  @Prop({ default: "" })
  public label!: string;
  @Prop({ default: false })
  public loading!: boolean;
}
